import request from '@/utils/request'
import api from '@/config/api'
const platform = localStorage.getItem('platform')

export function getKsSeriesAuthorizations(data) {
    return request.get(`/${platform}/ks_series_authorizations`, data)
}

/**
 * 短剧经营者平台拉取授权地址（与快手广告模块的拉取地址同构，仅 oauth_type 固定为 series）。
 * 后端返回 HTML 跳转脚本，需用 window.open 打开；接口需登录态，按项目既有做法把 token 放在 query 上。
 */
export function pullKsSeriesAuthorization(accountId) {
    const token = localStorage.getItem('token')
    return `${api.baseUrl}/${platform}/ks_series_authorizations/pull?account_id=${accountId}&token=${token}`
}
